<template>
    <div class="intro">
        <div class="container">
            <div class="row justify-conent-center">
                <div class="col-12">
                    <div class="intro__content">
                        <Icon class="intro__logo" icon="ecommerce_logo"/>
                        <div class="intro__text">
                            <TitleDescription
                                title="Dating platform for your ecommerce"
                            >
                                <template #description>
                                    <div class="intro__description-wrap d-sm-block d-none">
                                        <p class="intro__text-description"><b>Cross-Promote</b> with complementary brands</p>
                                        <p class="intro__text-description"><b>Increase</b> your sales and win more customers</p>
                                    </div>
                                    <div class="intro__description-wrap d-sm-none d-block">
                                        <p class="intro__text-description"><b>Cross-Promote</b> with complementary brands <b>Increase</b> your sales and win more customers </p>
                                    </div>
                                </template>
                            </TitleDescription>
                        </div>
                        <div class="intro__picture">

                            <lottie-animation
                                path="animation/ecommerce-landing.json"
                                :loop="true"
                                :autoPlay="true"
                                :speed="1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '../../../components/Theme/Icon'
import TitleDescription from '../../../components/Ecommerce/TitleDescription'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
    name: 'Intro',
    components: {
        Icon,
        TitleDescription,
        LottieAnimation
    }
}
</script>
<style lang="scss">
:root {
    --ecommerce-landing-intro-pic-gap: 80px;
    @media (max-height: 800px) {
        --ecommerce-landing-intro-pic-gap: 48px;
    }
}
</style>
<style lang="scss" scoped>
$background: #00002D;
$min_height: 100vh;
$headline_width: 488px;
$logo_gap: 24px;
$logo_sm_gap: 16px;
$description_fontsize: 18px;
$description_lineheight: 24px;
$description_fontsize_sm: 16px;
$description_lineheight_sm: 24px;
$white: #ffffff;
$picture_gap: var(--ecommerce-landing-intro-pic-gap);
$picture_gap_mob: 80px;

.intro {
    --title-fontsize: 40px;
    --title-lineheight: 48px;
    --title-margin-bottom: 8px;
    --title-color: #FCFDFE;
    
    @media (max-width: 576px) { 
        --title-fontsize: 24px;
        --title-lineheight: 32px;
    }

    background: $background;
    min-height: $min_height;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    &__content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    &__logo {
        margin-bottom: $logo_gap;
        @media (max-width: 576px) {
            margin-bottom: $logo_sm_gap;
        }
    }
    &__text {
        width: 100%;
        max-width: $headline_width;
        text-align: center;

        &-description {
            margin: 0;
            font-size: $description_fontsize;
            line-height: $description_lineheight;
            color: $white;
            @media (max-width: 576px) {
                font-size: $description_fontsize_sm;
            }
        }
    }
    &__description-wrap {
        margin-top: 8px;
    }
    &__picture {
        margin-top: $picture_gap;
        @media (max-width: 576px) {
            margin-top: $picture_gap_mob;
        }
    }
}
</style>>
